export const carouselItems = [
  {
    id: 1,
    tag: '独家爆料',
    title: '顶流男星深夜密会神秘女子 酒店共度8小时引全网猜测',
    excerpt: '据知情人士透露，该男星近期与一名圈外女子频繁约会，二人多次被目击同进同出某五星级酒店，关系非同寻常。工作室至今未作正面回应，粉丝群体已出现明显分裂。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20warm%20golden%20lighting%20spilling%20through%20glass%20doors%2C%20silhouetted%20figures%20entering%20the%20lobby%2C%20dark%20sophisticated%20atmosphere%20with%20rich%20contrasts%2C%20cinematic%20composition%2C%20mysterious%20and%20intriguing%20mood%2C%20commercial%20photography%20style%20with%20soft%20bokeh%20lights&width=800&height=500&seq=carousel-1&orientation=landscape',
    date: '2026-07-28',
    hot: true,
  },
  {
    id: 2,
    tag: '深度追踪',
    title: '知名导演被曝片场霸凌成性 多位演员实名举报揭露内幕',
    excerpt: '业内多位不愿透露姓名的演员联合发声，指该导演长期在片场使用语言暴力和精神打压手段。有受害者称曾因此患上抑郁症，但碍于对方在圈内的地位，一直忍气吞声。',
    image: 'https://readdy.ai/api/search-image?query=A%20tense%20film%20set%20scene%20with%20a%20directors%20chair%20in%20spotlight%2C%20dark%20studio%20backdrop%20with%20dramatic%20lighting%2C%20professional%20film%20equipment%20in%20shadows%2C%20cinematic%20photography%20with%20deep%20contrasts%2C%20somber%20and%20serious%20atmosphere%2C%20behind%20the%20scenes%20movie%20production%20aesthetic%2C%20warm%20spotlight%20on%20empty%20chair%20against%20darkness&width=800&height=500&seq=carousel-2&orientation=landscape',
    date: '2026-07-27',
    hot: true,
  },
  {
    id: 3,
    tag: '行业揭秘',
    title: '当红女团成员合约纠纷全面升级 经纪公司回应暗藏玄机',
    excerpt: '该女团三名核心成员同时向法院提起诉讼，要求解除与经纪公司的不平等合约。公司方面虽紧急发布声明称"积极沟通中"，但业内人士指出，此次纠纷涉及高达数千万的违约金条款。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20performance%20scene%20with%20three%20female%20performers%20in%20spotlight%2C%20dark%20concert%20arena%20with%20atmospheric%20stage%20lighting%2C%20silhouettes%20against%20bright%20backlight%2C%20entertainment%20industry%20atmosphere%2C%20emotional%20and%20powerful%20composition%2C%20professional%20concert%20photography%20with%20dramatic%20contrast&width=800&height=500&seq=carousel-3&orientation=landscape',
    date: '2026-07-26',
    hot: false,
  },
  {
    id: 4,
    tag: '现场直击',
    title: '综艺节目录制现场爆发激烈冲突 嘉宾当场罢录视频网络疯传',
    excerpt: '一段在现场观众席偷拍的视频显示，某热门综艺录制过程中，两位嘉宾因游戏环节的裁判结果发生口角，随后演变为肢体推搡。节目组紧急叫停录制，但相关视频已在社交平台广泛传播。',
    image: 'https://readdy.ai/api/search-image?query=A%20chaotic%20TV%20studio%20set%20with%20bright%20stage%20lights%20and%20cameras%2C%20two%20figures%20in%20heated%20confrontation%20in%20the%20center%2C%20crew%20members%20rushing%20in%20from%20the%20edges%2C%20dramatic%20lighting%20with%20red%20and%20blue%20highlights%2C%20reality%20show%20production%20aesthetic%2C%20tense%20and%20chaotic%20atmosphere%2C%20behind%20the%20scenes%20television%20studio%20photography&width=800&height=500&seq=carousel-4&orientation=landscape',
    date: '2026-07-25',
    hot: true,
  },
  {
    id: 5,
    tag: '资本暗战',
    title: '某资本大佬娱乐圈投资版图遭起底 涉及多位一线艺人利益链',
    excerpt: '调查发现，该资本方通过多层嵌套的壳公司体系，间接控制了近二十家娱乐相关企业，形成了一个从艺人经纪、内容制作到平台分发的全链条布局。多位一线明星均与其存在深度利益绑定。',
    image: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20corporate%20boardroom%20scene%20with%20dark%20wood%20paneling%20and%20dim%20ambient%20lighting%2C%20a%20large%20conference%20table%20with%20scattered%20documents%20and%20a%20tablet%2C%20dramatic%20shadows%20from%20venetian%20blinds%2C%20ominous%20business%20atmosphere%2C%20financial%20thriller%20aesthetic%2C%20high%20contrast%20cinematic%20photography%2C%20mysterious%20corporate%20power%20vibe&width=800&height=500&seq=carousel-5&orientation=landscape',
    date: '2026-07-24',
    hot: false,
  },
];

export const updateItems = [
  {
    id: 1,
    time: '12分钟前',
    category: '独家',
    title: '某选秀冠军被曝与经纪人关系暧昧 工作室连夜发律师函',
    summary: '多位自称知情人士的网友在社交平台发布聊天截图，声称两人早已同居。工作室凌晨三点紧急发布声明否认，并称将追究造谣者法律责任。',
  },
  {
    id: 2,
    time: '28分钟前',
    category: '最新',
    title: '热门网剧男主私生活混乱实锤 多名女子先后晒出亲密照',
    summary: '三位身份各异的女性先后在社交平台公开与该男星的私密合影，时间线相互交叉，被网友制作成时间图谱疯传。',
  },
  {
    id: 3,
    time: '1小时前',
    category: '追踪',
    title: '知名歌手税务问题持续发酵 官方税务部门已正式介入调查',
    summary: '自上周爆料以来，该歌手代言的五个品牌已先后宣布暂停合作。其工作室否认存在主观逃税行为，称"系财务团队工作失误"。',
  },
  {
    id: 4,
    time: '2小时前',
    category: '爆料',
    title: '某综艺节目剪辑造假内幕 选手真实排名与播出结果相差悬殊',
    summary: '一位已离职的节目后期人员爆料，该节目每期播出前都进行大量"剧情化剪辑"，将表现平平的选手剪成黑马，将实力选手恶意剪辑成争议角色。',
  },
  {
    id: 5,
    time: '3小时前',
    category: '独家',
    title: '当红小花被扒早年黑历史 学历造假风波再度引发舆论热议',
    summary: '网友挖掘出该女星高中时期的社交账号，发现其自称"在读大学生"期间实际并未参加高考。其粉丝后援会紧急组织控评，相关话题一度登上热搜。',
  },
  {
    id: 6,
    time: '5小时前',
    category: '快讯',
    title: '某导演新片拍摄现场突发安全事故 剧组被质疑隐瞒真实情况',
    summary: '据现场工作人员透露，事故涉及三名特技演员受伤，但剧组对外仅表示"轻微擦伤"。受伤演员家属已在医院发声，要求剧组公开说明。',
  },
  {
    id: 7,
    time: '6小时前',
    category: '揭秘',
    title: '娱乐圈某大佬背后的资本运作链条 多家公司被曝存在关联交易',
    summary: '一份内部审计报告显示，该大佬控制的五家公司之间存在频繁的资金往来，总额超过3亿元，且多笔交易缺乏合理商业目的。',
  },
  {
    id: 8,
    time: '8小时前',
    category: '内幕',
    title: '知名主持人私下不当言论录音曝光 涉及多位同行惊人隐私',
    summary: '一段长达45分钟的录音在圈内小范围流传，该主持人在私人饭局中大肆谈论同行私生活，内容尺度极大，目前已有多位被提及艺人表示震惊和愤怒。',
  },
  {
    id: 9,
    time: '10小时前',
    category: '最新',
    title: '某品牌代言人突然宣布解约 背后原因疑为负面新闻即将爆发',
    summary: '该明星团队在解约公告中使用了罕见的强硬措辞，称"基于个人原则决定终止合作"。但多方消息源透露，实际原因是某调查报道即将发布。',
  },
];

export const cardItems = [
  {
    id: 1,
    tag: '年度盘点',
    title: '顶流塌房全记录：那些年我们一起追过的明星翻车史',
    excerpt: '从税务风波到私德争议，从学术造假到违法行为，梳理近三年娱乐圈重大翻车事件，深度分析背后的行业生态与粉丝文化变迁。',
    image: 'https://readdy.ai/api/search-image?query=A%20collage%20style%20editorial%20image%20showing%20a%20fallen%20spotlight%20on%20a%20dark%20stage%2C%20cracked%20golden%20star%20on%20the%20floor%2C%20dramatic%20theatrical%20lighting%20with%20deep%20shadows%2C%20entertainment%20industry%20metaphor%2C%20cinematic%20composition%20with%20warm%20and%20dark%20tones%2C%20symbolic%20downfall%20aesthetic%2C%20professional%20photography&width=600&height=400&seq=card-1&orientation=landscape',
    date: '2026-07-15',
    views: 128000,
  },
  {
    id: 2,
    tag: '深度调查',
    title: '娱乐圈潜规则大起底：从选角到资源分配的暗箱操作全链条',
    excerpt: '采访了七位不同岗位的业内人士，还原了一条完整的"资源置换"产业链。从试镜房间的秘密到投资方的隐性要求，这个行业的水远比想象中深。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20backstage%20corridor%20with%20faint%20warm%20light%20leaking%20from%20a%20partially%20open%20door%2C%20casting%20long%20shadows%20on%20the%20floor%2C%20old%20theater%20aesthetic%20with%20velvet%20curtains%2C%20atmospheric%20and%20secretive%20mood%2C%20behind%20the%20scenes%20entertainment%20industry%2C%20cinematic%20noir%20photography%20with%20rich%20contrasts&width=600&height=400&seq=card-2&orientation=landscape',
    date: '2026-07-14',
    views: 96000,
  },
  {
    id: 3,
    tag: '对比分析',
    title: '女明星整容前后深度对比：这些惊人的变化你真的看出来了吗',
    excerpt: '通过专业医美医生的视角，逐帧分析近二十位女星的面部变化轨迹。从微调到换头，每个细节都被放大解读，附带行业内幕解读。',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20composition%20of%20a%20vanity%20mirror%20with%20dramatic%20lighting%2C%20one%20side%20in%20warm%20soft%20glow%20the%20other%20in%20cool%20shadow%2C%20cosmetic%20products%20on%20a%20marble%20counter%2C%20beauty%20industry%20aesthetic%2C%20editorial%20fashion%20photography%2C%20contrasting%20tones%20and%20reflections%2C%20luxurious%20dressing%20room%20atmosphere&width=600&height=400&seq=card-3&orientation=landscape',
    date: '2026-07-13',
    views: 215000,
  },
  {
    id: 4,
    tag: '技术解密',
    title: '综艺节目造假手法终极揭秘：从剧本设计到后期剪辑的完整手册',
    excerpt: '由前综艺导演亲自执笔，详细图解一档"真人秀"如何从前期人物设定到后期剪辑被一步步加工成观众看到的"真实反应"。看完你将怀疑所有综艺。',
    image: 'https://readdy.ai/api/search-image?query=A%20video%20editing%20suite%20with%20multiple%20monitors%20displaying%20timeline%20and%20color%20grading%20interfaces%2C%20dark%20room%20illuminated%20only%20by%20screen%20glow%2C%20professional%20post%20production%20environment%2C%20technical%20and%20mysterious%20atmosphere%2C%20film%20editing%20aesthetic%2C%20cinematic%20workspace%20photography%2C%20deep%20shadows%20with%20colorful%20screen%20reflections&width=600&height=400&seq=card-4&orientation=landscape',
    date: '2026-07-12',
    views: 89000,
  },
  {
    id: 5,
    tag: '资本解读',
    title: '明星天价片酬背后的资本游戏：到底是谁在为此疯狂买单',
    excerpt: '深入剖析影视行业完整的资金链路，从平台采购预算、广告招商对赌到明星片酬分成。一张图看懂一个亿的片酬是如何被层层加码出来的。',
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20office%20with%20a%20large%20glass%20desk%20covered%20in%20stacked%20banknotes%20and%20financial%20documents%2C%20dramatic%20lighting%20from%20a%20single%20overhead%20source%2C%20dark%20sophisticated%20corporate%20setting%2C%20wealth%20and%20power%20aesthetic%2C%20cinematic%20photography%20with%20rich%20golden%20and%20dark%20tones%2C%20high%20contrast%20editorial%20style&width=600&height=400&seq=card-5&orientation=landscape',
    date: '2026-07-11',
    views: 73000,
  },
  {
    id: 6,
    tag: '情感揭秘',
    title: '明星夫妻背后的真实婚姻状况：表面恩爱人设下暗流涌动的真相',
    excerpt: '盘点近一年来被媒体拍到且未被公关掉的十对"问题夫妻"，从分居、各玩各的到貌合神离的商业联姻，扒开娱乐圈婚姻的遮羞布。',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20scene%20showing%20two%20figures%20sitting%20at%20opposite%20ends%20of%20a%20long%20dining%20table%20in%20a%20luxurious%20room%2C%20dim%20candlelight%2C%20distant%20and%20cold%20atmosphere%2C%20emotional%20distance%20metaphor%2C%20cinematic%20composition%20with%20dramatic%20lighting%2C%20sophisticated%20interior%2C%20relationship%20tension%20aesthetic%2C%20warm%20but%20melancholic%20tones&width=600&height=400&seq=card-6&orientation=landscape',
    date: '2026-07-10',
    views: 156000,
  },
  {
    id: 7,
    tag: '行业观察',
    title: '网红转型明星的成功率到底有多低：这条路远比想象中更残酷',
    excerpt: '统计了过去五年间尝试跨界影视圈的三百余位网红，发现仅有不到3%的人获得了持续的发展机会。数据背后，是平台算法与影视工业之间的巨大鸿沟。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20image%20of%20a%20spotlight%20casting%20a%20narrow%20beam%20onto%20an%20empty%20stage%2C%20surrounded%20by%20darkness%2C%20a%20single%20figure%20barely%20visible%20at%20the%20edge%20of%20the%20light%2C%20theatrical%20audition%20atmosphere%2C%20symbolic%20of%20competition%20and%20struggle%2C%20cinematic%20photography%20with%20high%20contrast%2C%20dramatic%20and%20emotional%20tone&width=600&height=400&seq=card-7&orientation=landscape',
    date: '2026-07-09',
    views: 62000,
  },
];

export const indexItems = [
  {
    id: 1,
    title: '明星八卦',
    description: '最新明星动态、绯闻恋情、私下生活揭秘，每日更新海量独家爆料',
    icon: 'ri-star-line',
    count: 3286,
    color: 'primary',
  },
  {
    id: 2,
    title: '影视内幕',
    description: '电影电视剧拍摄幕后故事、选角暗箱、片酬纠纷、剧组真相大公开',
    icon: 'ri-film-line',
    count: 2145,
    color: 'accent',
  },
  {
    id: 3,
    title: '综艺真相',
    description: '热门综艺节目的剧本设计、剪辑操控、嘉宾关系内幕全程解密',
    icon: 'ri-tv-line',
    count: 1892,
    color: 'secondary',
  },
  {
    id: 4,
    title: '音乐圈揭秘',
    description: '歌手合约纠纷、音源造假、抄袭争议、演唱会内幕深度报道',
    icon: 'ri-music-line',
    count: 1567,
    color: 'primary',
  },
  {
    id: 5,
    title: '资本暗战',
    description: '娱乐圈投资并购、利益输送、股权结构、资本大佬幕后操作解析',
    icon: 'ri-funds-line',
    count: 1234,
    color: 'accent',
  },
  {
    id: 6,
    title: '时尚争议',
    description: '红毯造型翻车、品牌代言争夺、时尚圈潜规则、模特行业揭秘',
    icon: 'ri-shirt-line',
    count: 987,
    color: 'secondary',
  },
  {
    id: 7,
    title: '直播带货',
    description: '明星直播带货内幕、刷单造假、产品质量争议、佣金分成揭秘',
    icon: 'ri-live-line',
    count: 756,
    color: 'primary',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '51黑料网是什么？和普通娱乐新闻网站有什么不同？',
    answer: '51黑料网是一个专注于娱乐圈深度爆料和独家内幕的资讯聚合平台。与传统娱乐新闻网站不同，我们不满足于转载官方通稿和表面报道，而是通过独立的消息源网络，为你提供更深层次、更真实的娱乐行业动态。从明星私生活到影视资本运作，从综艺造假到行业潜规则，我们致力于让每一位读者看到镜头之外的真相。',
  },
  {
    id: 2,
    question: '如何确保能随时访问51黑料网？最新地址在哪里可以获取？',
    answer: '由于平台内容的特殊性，我们的访问入口可能会不定期调整以确保服务稳定。建议您将本页面加入浏览器收藏夹，我们会在首页顶部和"最新快讯"模块中及时公告最新的访问地址。您也可以关注我们的官方社交媒体账号获取实时更新的入口信息。所有地址变更均会通过首页公告第一时间通知读者。',
  },
  {
    id: 3,
    question: '网站上的内容是否真实可靠？消息来源是什么？',
    answer: '我们建立了严格的多源交叉验证机制，每条核心爆料在发布前至少经过两个独立来源的核实。我们的消息来源覆盖行业内的经纪人、制作人、媒体记者、离职员工等多个层面。同时我们会在每篇报道中标注消息的可信度等级，帮助读者独立判断。需要说明的是，娱乐圈信息本身具有不确定性，我们鼓励读者保持理性思考和批判性阅读。',
  },
  {
    id: 4,
    question: '我有独家爆料想要投稿，应该如何联系你们？',
    answer: '我们非常欢迎来自各方的独家消息和线索。您可以通过页面下方的"联系投稿"模块找到我们的联系方式。我们承诺对所有爆料人的身份信息严格保密，并采用业界领先的加密通讯方式保护您的安全。对于经过核实并发布的重大独家爆料，我们会按照内容价值给予丰厚的线索奖励。',
  },
];

export const featureItems = [
  {
    id: 1,
    title: '全网最快爆料速度',
    description: '拥有覆盖全娱乐产业的独立消息源网络，重大事件发生后的30分钟内即可获取第一手信息并完成核实发布，比主流媒体平均快4-6小时。',
    icon: 'ri-flashlight-line',
  },
  {
    id: 2,
    title: '独家深度内容',
    description: '超过80%的核心报道为平台独家，深耕艺人背景调查、资本关系图谱和行业黑幕解密，提供市面上无法获取的深度资讯和独到视角。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 3,
    title: '安全匿名访问',
    description: '采用先进的技术架构确保用户访问的隐私安全，无需注册即可浏览全部内容。支持多种加密访问方式，让你安心获取最新黑料资讯。',
    icon: 'ri-lock-line',
  },
];

export const aboutContent = {
  title: '关于51黑料网',
  paragraphs: [
    '51黑料网创立于2019年，是国内领先的娱乐资讯深度爆料平台。我们从一个小型的行业内部交流社区起步，凭借独立、真实的报道风格和遍布娱乐圈的消息源网络，逐步成长为拥有数百万月活跃读者的成熟运营站点。',
    '我们的团队由资深娱乐记者、前影视行业从业者和数据分析专家组成，秉持"拒绝通稿，只讲真相"的理念，专注于挖掘娱乐圈镜头之外的深层故事。无论是明星八卦、影视内幕、综艺真相还是资本暗战，我们都致力于为读者提供最及时、最深度的资讯服务。',
    '作为一个独立运营的内容平台，51黑料网不接受任何娱乐公司的内容合作邀约，也从未向任何报道对象收取过"公关费"或"删稿费"。这种独立性让我们能够保持报道的客观和锐度，也因此赢得了广大读者的信任和口碑。',
    '未来，我们将继续扩大消息源网络，提升内容质量，探索更多元的呈现方式，为每一位关注娱乐行业的读者提供更好的资讯体验。51黑料网，做你看见真相的眼睛。',
  ],
};

export const contactContent = {
  title: '联系投稿',
  description: '我们欢迎来自各方的独家消息和新闻线索。如果你掌握娱乐圈的幕后故事、内幕信息或不为人知的真相，请通过以下方式联系我们。所有爆料人信息将受到最高级别的保护。',
  email: 'tips@51heiliaowang.com',
  methods: [
    { name: '投稿邮箱', value: 'tips@51heiliaowang.com', icon: 'ri-mail-line' },
    { name: '加密通讯', value: 'Signal / Telegram', icon: 'ri-shield-keyhole-line' },
    { name: '工作时间', value: '周一至周日 9:00 - 24:00', icon: 'ri-time-line' },
  ],
};

export const commentItems = [
  {
    id: 1,
    author: '吃瓜一线网友',
    content: '这个网站真的太敢说了！别的平台都在发通稿，只有这里能看到真实的内幕。尤其是那篇关于综艺剪辑造假的文章，看完之后再看任何综艺都觉得不对劲了。',
    date: '2026-07-28',
    likes: 2389,
  },
  {
    id: 2,
    author: '娱乐行业老兵',
    content: '作为在娱乐圈摸爬滚打了十五年的人，我可以负责任地说，51黑料网的很多报道都是圈内人才知道的事情。来源非常可靠，分析也很专业，不是一般八卦号能比的。',
    date: '2026-07-27',
    likes: 1856,
  },
  {
    id: 3,
    author: '匿名用户A',
    content: '之前在这里看到一条关于某导演的爆料，一开始觉得太夸张了。结果三个月后官方通报出来，居然和这里说的基本一致。从此成了铁粉，每天都来刷更新。',
    date: '2026-07-26',
    likes: 3201,
  },
  {
    id: 4,
    author: '追星十年不改初心',
    content: '虽然有时候看到自己偶像的爆料会很难受，但还是选择面对真相而不是活在信息茧房里。感谢这个平台坚持做真实的报道，也希望大家理性看待，不要盲目全信也不要全盘否定。',
    date: '2026-07-25',
    likes: 1567,
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '顶流男星深夜密会神秘女子事件全追踪', hot: '🔥🔥🔥🔥🔥', tag: '爆', views: '258万' },
  { id: 2, rank: 2, title: '综艺节目录制现场冲突视频完整分析', hot: '🔥🔥🔥🔥', tag: '热', views: '196万' },
  { id: 3, rank: 3, title: '知名导演片场霸凌受害者实名举报合集', hot: '🔥🔥🔥🔥', tag: '热', views: '173万' },
  { id: 4, rank: 4, title: '当红小花学历造假风波持续发酵追踪', hot: '🔥🔥🔥', tag: '新', views: '142万' },
  { id: 5, rank: 5, title: '资本大佬娱乐圈投资版图全面起底', hot: '🔥🔥🔥', tag: '热', views: '128万' },
  { id: 6, rank: 6, title: '女团合约纠纷：三大核心成员同时解约', hot: '🔥🔥🔥', tag: '新', views: '115万' },
];

export const mediaItems = [
  {
    id: 1,
    title: '独家专访：前综艺导演揭露节目造假全流程',
    duration: '28:45',
    views: '89.2万',
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20interview%20setup%20with%20a%20silhouetted%20figure%20sitting%20in%20a%20dark%20studio%2C%20dramatic%20single%20light%20source%20from%20above%2C%20anonymous%20whistleblower%20aesthetic%2C%20investigative%20journalism%20atmosphere%2C%20cinematic%20portrait%20lighting%20with%20deep%20shadows%2C%20mysterious%20and%20serious%20mood%2C%20documentary%20style%20photography&width=600&height=400&seq=media-1&orientation=landscape',
  },
  {
    id: 2,
    title: '深度解析：明星天价片酬背后的完整产业链',
    duration: '35:12',
    views: '67.8万',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20data%20visualization%20scene%20with%20holographic%20charts%20and%20graphs%20floating%20in%20a%20dark%20room%2C%20financial%20analysis%20aesthetic%2C%20glowing%20golden%20data%20points%2C%20business%20investigation%20atmosphere%2C%20cinematic%20tech%20noir%20photography%2C%20dramatic%20lighting%20with%20warm%20accents%2C%20professional%20documentary%20style&width=600&height=400&seq=media-2&orientation=landscape',
  },
  {
    id: 3,
    title: '实拍记录：娱乐圈选角房间里的那些暗箱操作',
    duration: '22:08',
    views: '54.3万',
    image: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20audition%20room%20with%20a%20single%20chair%20under%20a%20spotlight%2C%20empty%20except%20for%20shadows%20of%20observers%20behind%20a%20one%20way%20mirror%2C%20casting%20session%20atmosphere%2C%20theatrical%20tension%2C%20dramatic%20cinematic%20photography%2C%20behind%20the%20scenes%20entertainment%20industry%2C%20mysterious%20and%20uncomfortable%20mood&width=600&height=400&seq=media-3&orientation=landscape',
  },
  {
    id: 4,
    title: '揭秘系列：娱乐圈大佬们的隐秘资本运作网络',
    duration: '42:30',
    views: '43.1万',
    image: 'https://readdy.ai/api/search-image?query=A%20complex%20network%20diagram%20projected%20on%20a%20dark%20wall%20with%20interconnected%20nodes%20and%20lines%2C%20a%20figure%20standing%20in%20front%20tracing%20connections%2C%20investigative%20research%20atmosphere%2C%20conspiracy%20mapping%20aesthetic%2C%20dramatic%20lighting%2C%20cinematic%20thriller%20style%20photography%2C%20dark%20and%20serious%20mood&width=600&height=400&seq=media-4&orientation=landscape',
  },
];

export const appContent = {
  title: '随时随地看黑料',
  description: '51黑料网移动版适配所有设备，无需下载安装，浏览器直接访问即可获得完整的阅读体验。无论你使用手机、平板还是电脑，都能随时随地获取最新的娱乐爆料资讯。',
  features: [
    '全平台自适应访问',
    '推送最新爆料通知',
    '暗色模式夜间阅读',
    '一键直达最新地址',
  ],
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20dark%20themed%20news%20app%20interface%20with%20breaking%20entertainment%20headlines%20in%20Chinese%2C%20floating%20in%20a%20dark%20atmosphere%20with%20warm%20golden%20light%20accents%2C%20minimal%20product%20photography%2C%20sleek%20and%20professional%2C%20clean%20background%20with%20soft%20glow%2C%20premium%20mobile%20device%20presentation&width=400&height=800&seq=app-1&orientation=portrait',
};

export const topicItems = [
  { id: 1, name: '顶流塌房', count: 1286, hot: true },
  { id: 2, name: '综艺造假', count: 987, hot: true },
  { id: 3, name: '明星税务', count: 856, hot: true },
  { id: 4, name: '合约纠纷', count: 742, hot: false },
  { id: 5, name: '导演霸凌', count: 698, hot: true },
  { id: 6, name: '学历造假', count: 621, hot: false },
  { id: 7, name: '资本运作', count: 583, hot: false },
  { id: 8, name: '潜规则', count: 547, hot: true },
  { id: 9, name: '片酬内幕', count: 489, hot: false },
  { id: 10, name: '整容对比', count: 432, hot: false },
  { id: 11, name: '品牌解约', count: 376, hot: true },
];

export const siteInfo = {
  name: '51黑料网',
  slogan: '看见镜头之外的真相',
  description: '51黑料网是国内领先的娱乐资讯深度爆料平台，致力于为读者提供最及时、最真实的娱乐圈独家内幕和深度报道。',
};